import { render, staticRenderFns } from "./SharedLinkDeleteDialogBox.vue?vue&type=template&id=54a35c21&scoped=true&"
import script from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a35c21",
  null
  
)

export default component.exports